import React, { useEffect, useState } from "react";
import {
  Card,
  Col,
  Row,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import ReactLogo from "../asset/img/reactlogo.png";
import { serverUrl } from "../config";
import { fileDto } from "../dto/file";

function IndexPage(props: IndexPage_props) {
  const [datas, setDatas] = useState<Array<box>>([])

  useEffect(() => {
    fetch(`${serverUrl}`)
      .then((res) => res.json())
      .then((dts) => {
        setDatas(dts.files.map((d: fileDto) => { return {
          id: d.id,
          desc: d.desc,
          mdName: `${d.fileName}.md`,
          title: d.title,
        }}))})
      }, [])


  return (
    <Col xs={12}>
          <Row xs={1} md={2} className="g-4">
            {Array.from(datas).map((_, idx) => (
                <Col style={{ width: "12vw", minWidth: "200px"}} key={_.id} >
                  <Link to={`/md/${_.mdName}`}>
                    <Card>
                      <Card.Img className="mx-auto"
                        variant="top"
                        src={ReactLogo}
                      />
                      <Card.Body>
                        <Card.Title>{_.title}</Card.Title>
                        <Card.Text>
                          {_.desc}
                        </Card.Text>
                      </Card.Body>
                    </Card>
                  </Link>

              </Col>

            ))}
          </Row>
</Col>
  );
}

export default IndexPage;

